<script lang="ts" setup>
import { defineComponent } from 'vue'
</script>

<script lang="ts">
export default defineComponent({
  name: 'NotFound',
})
</script>

<template>
  <div class="py-20 w-50 mx-a text-center">
    <img class="w-100px inline" src="@/assets/cover-empty.png">
    <p class="mt-14px text-center text-#666 text-13px">
      Page not found
    </p>

    <div class="flex justify-center">
      <router-link :to="{ name: 'home' }" replace>
        <button class="mt-15 px-4 py-2 text-primary border-primary border-1 border-solid rounded-full">
          Go to Home Page
        </button>
      </router-link>
    </div>
  </div>
</template>
